export default "__VITE_ASSET__CxrRUGlN__"